import React from 'react';
import { useCustomElement } from '../UseCustomElement';

export type ZuiIconProps = {
  noColor?: true | null;
  icon?: string;
} & React.HTMLAttributes<HTMLElement>;

export const ZuiIcon = (props: ZuiIconProps) => {
  const selector = 'zui-icon';
  const customMappings = {
    noColor: 'no-color',
  };
  return useCustomElement(selector, props, customMappings);
};
